import { useState, useContext } from "react";
import { RegulationContext } from "../../../core/context/regulationContextProvider";
import { FormContext } from "../../../core/context/formContextProvider";
import {
  iTypeFormCategories,
  regulationContextTypes,
  formContextTypes,
  typeFormDto,
} from "../../../utils/typeDefs";
import { Table } from "rsuite";
import ReusableModal from "../modal/reusableModal.component";
import FormsModal from "../modal/formsModal.component";
import RegulationsModal from "../modal/regulationsModal.component";
import EditIcon from "@rsuite/icons/Edit";
import TrashIcon from "@rsuite/icons/Trash";
import InfoOutlineIcon from "@rsuite/icons/InfoOutline";

const { Cell } = Table;

type formProps = {
  rowData?: typeFormDto;
  dataKey?: string | number;
  rowIndex?: number;
  setUrlId: (value: number) => void;
  handleConfirm: () => void;
  handleDelete: () => void;
  handleEdit: () => void;
  modalType: string | null;
  formCategoryData?: iTypeFormCategories[];
  setData: (value: typeFormDto[] | null) => void;
  url: string;
  setModalType: (value: string | null) => void;
};

export const EditableActionCell = ({
  rowData,
  dataKey,
  handleDelete,
  handleEdit,
  setUrlId,
  handleConfirm,
  modalType,
  formCategoryData,
  setData,
  setModalType,
  url,
  ...props
}: formProps) => {
  const value = (rowData && dataKey && rowData.id) as number;

  const regulationContext = useContext(
    RegulationContext,
  ) as regulationContextTypes;

  const formContext = useContext(FormContext) as formContextTypes;

  const deleteModal = (
    <div className="d-flex flex-column align-items-center">
      <InfoOutlineIcon className="mb-2 delete-alert-icon" />
      <h3>Are you sure you want to delete?</h3>
    </div>
  );

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [modalChild, setModalChild] = useState<JSX.Element | null>(null);

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setModalType(null);
    setOpenModal(false);
  };

  return (
    <>
      <ReusableModal
        modalType={modalType}
        modalTitle={`${rowData?.title}`}
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        children={modalChild}
        handleConfirm={handleConfirm}
      />
      <Cell {...props}>
        <div className="align-items-center">
          <div
            className="p-1 "
            onClick={() => {
              if (url === "Regulation") {
                setModalChild(
                  <RegulationsModal
                    id={value}
                    countryId={rowData ? rowData.countryId : null}
                    modalType={"edit"}
                    regulationCategoryData={formCategoryData}
                    handleCloseModal={handleCloseModal}
                    setData={setData}
                    loadData={true}
                    currentRowData={
                      regulationContext
                        ? regulationContext.currentRowData
                        : null
                    }
                  />,
                );
              } else {
                setModalChild(
                  <FormsModal
                    id={value}
                    countryId={rowData ? rowData.countryId : null}
                    modalType={"edit"}
                    formCategoryData={formCategoryData}
                    handleCloseModal={handleCloseModal}
                    setData={setData}
                    loadData={true}
                    currentRowData={
                      formContext ? formContext.currentRowData : null
                    }
                  />,
                );
              }
            }}
          >
            <EditIcon
              onClick={() => {
                setUrlId(value);
                handleEdit();
                if (url === "Form") {
                  formContext.setCurrentId(value);
                } else regulationContext.setCurrentId(value);
                handleOpenModal();
              }}
              className="action-icon edit-icon"
              color="#172636"
            />
          </div>
          <div
            className="p-1 cursor-type"
            onClick={() => {
              setModalChild(deleteModal);
            }}
          >
            <TrashIcon
              onClick={() => {
                setUrlId(value);
                handleDelete();
                handleOpenModal();
              }}
              className="action-icon delete-icon"
              color="#172636"
            />
          </div>
        </div>

        <span className="ms-3 d-none">{value}</span>
      </Cell>
    </>
  );
};
